import React from 'react'
import { fontWeight, spacing } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { useDashMessages } from 'intl/intl.hooks'

const StyledContainer = styled.div({
  paddingTop: spacing.X64,
  textAlign: 'center',
  maxWidth: 500,
  margin: '0 auto',

  '.header': {
    fontWeight: fontWeight.SEMIBOLD,
    margin: spacing.X20,
  },

  '.content': {
    marginBottom: spacing.X20,
  },
})

export const BannerDetailsNotSupported: React.FunctionComponent = () => {
  const messages = useDashMessages({
    header: 'bannersDomain.details.not-supported.header',
    content: 'bannersDomain.details.not-supported.content',
  })

  return (
    <StyledContainer data-testid="error-page">
      <div className="header">{messages.header}</div>
      <div className="content">{messages.content}</div>
    </StyledContainer>
  )
}
